import SuiteForm from 'src/components/SuiteForm';
import Overlay from 'src/components/Overlay';
import FontAwesomeIcon from 'src/components/Icon';
import Button from 'src/components/Button';
import { MobileDownloadIcon } from 'src/components/SuitesTable/components/mobileDownloadIcon';

interface SuiteActionsProps {
  isHomeOwnerCheckUser: boolean;
  suite: any;
  suiteFormData: any;
  user: any;
  onToggleMobileSync: () => void;
  onReRenderKeyPickupPdf: () => void;
  onFetchDetails: () => void;
  onEditSuite: () => void;
  onDeleteUnit: (suiteId: string) => void;
  showOverlay: boolean;
  onCloseOverlay: () => void;
  onSaveSuite: (data: any, areas: any, floorImage: any) => void;
}

const SuiteActions = ({
  isHomeOwnerCheckUser,
  suite,
  suiteFormData,
  user,
  onToggleMobileSync,
  onReRenderKeyPickupPdf,
  onFetchDetails,
  onEditSuite,
  onDeleteUnit,
  showOverlay,
  onCloseOverlay,
  onSaveSuite,
}: SuiteActionsProps) => {
  if (isHomeOwnerCheckUser) {
    return null;
  }

  const userRole: any = user.roles[0]?.role.name;
  const canHandleKeys: boolean = [
    'Property Developer',
    'Admin',
    'Super Admin',
  ].includes(userRole);
  const isKeyHandedOff: any = suite.isKeyHandOff || suiteFormData?.isKeyHandOff;

  return (
    <>
      {/* Mobile Sync Toggle. */}
      {suite.mobileSyncAllowed !== undefined && (
        <MobileDownloadIcon property={suite} onClick={onToggleMobileSync} />
      )}
      {/* Key Handoff Actions. */}
      {isKeyHandedOff ? (
        <Button
          color="semantic"
          onClick={onReRenderKeyPickupPdf}
          label={<FontAwesomeIcon glyph="redo-alt" weight="solid" />}
        />
      ) : (
        canHandleKeys && (
          <Button
            color="semantic"
            onClick={onFetchDetails}
            label={<FontAwesomeIcon glyph="key" weight="solid" />}
          />
        )
      )}
      {/* Edit Suite Button. */}
      <Button
        color="semantic"
        onClick={onEditSuite}
        label={<FontAwesomeIcon glyph="pencil" weight="solid" />}
      />
      {/* Delete Suite Button. */}
      <Button
        color="semantic"
        onClick={() => {
          const confirmed = window.confirm(
            `Are you sure you want to delete ${suite.number}?`
          );
          if (confirmed) {
            onDeleteUnit(suite.id);
          }
        }}
        label={
          <FontAwesomeIcon
            glyph="trash"
            weight="solid"
            style={{ color: '#C00' }}
          />
        }
      />
      {/* Suite Edit Form Overlay. */}
      <Overlay
        showOverlay={showOverlay}
        content={
          <SuiteForm onClose={onCloseOverlay} onSaveSuite={onSaveSuite} />
        }
      />
    </>
  );
};

export default SuiteActions;
